import { UseFormReturn } from "react-hook-form";
import { ProjectAboutFormData } from "./schema";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { } from "@/components/ui/select";

export function ProjectAboutForm({ form }: { form: UseFormReturn<ProjectAboutFormData> }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Título */}
      <FormField
        control={form.control}
        name="title"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white">Título <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Digite seu nome" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Número Salic do projeto */}
      <FormField
        control={form.control}
        name="salicNumber"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white">Número Salic <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Digite o número Salic" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Proponente */}
      <FormField
        control={form.control}
        name="proponent"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white">Proponente <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Digite o número Salic" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* CNPJ do proponente */}
      <FormField
        control={form.control}
        name="cnpjProponent"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white">CNPJ do proponente <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Digite aqui" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Data prevista de lançamento */}
      <FormField
        control={form.control}
        name="releaseDate"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white">Data prevista de lançamento <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input
                type="date"
                placeholder="00/00/0000"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Número de Episódios (série) */}
      <FormField
        control={form.control}
        name="episodeCount"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white">Número de Episódios (série)</FormLabel>
            <FormControl>
              <Input
                type="number"
                placeholder="Digite aqui"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Tempo de episódio (série) */}
      <FormField
        control={form.control}
        name="episodeDuration"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white">Tempo de episódio (série)</FormLabel>
            <FormControl>
              <Input placeholder="Digite aqui" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Segmento */}
      <FormField
        control={form.control}
        name="segment"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white">Segmento</FormLabel>
            <FormControl>
              <Input placeholder="Digite aqui" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Gênero */}
      <FormField
        control={form.control}
        name="genre"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white">Gênero <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Digite aqui" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Formato */}
      <FormField
        control={form.control}
        name="format"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white">Formato</FormLabel>
            <FormControl>
              <Input placeholder="Digite aqui" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Logline - ocupa toda a largura */}
      <div className="md:col-span-2">
        <FormField
          control={form.control}
          name="logline"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-white">Logline <span className="text-red-500">*</span></FormLabel>
              <FormControl>
                <Input
                  placeholder="Digite aqui"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}